import { Calculator } from '@homevest/calculator'

import {
  UPDATE_CALCULATOR_CONFIG,
  UPDATE_CALCULATOR_CONFIG_2
} from './actions'
import homes from '../../data/homes'

function getProjectionData (budget, equityBuyback, calculator) {
  const initialOptionPremium = budget * 2

  calculator.updateConfig({
    rent: budget,
    initialOptionPremium,
    targetMonthlyOptionPremium: equityBuyback
  })

  const data = calculator.getOptionValueProjections(4, true)

  data.unshift(initialOptionPremium)

  return data
}

function getRentingData (budget, equityBuyback) {
  // return [0, 1, 2, 3, 4].map(year => (budget * 2 + (equityBuyback * year * 12)))
  return [0, 1, 2, 3, 4].map(() => budget * 2)
}

function getInitialState () {
  const calculator = new Calculator(homes['2915'].config)
  return {
    value: 2500,
    equityBuyback: 200,
    rentingData: getRentingData(2500, 200),
    projectionData: getProjectionData(2500, 200, calculator),
    calculator
  }
}

export default function reducer (state = getInitialState(), action) {
  switch (action.type) {
    case UPDATE_CALCULATOR_CONFIG_2:
      const calculator2 = new Calculator(action.config)
      const budget2 = action.config.tenantTerms.rent
      const equityBuyback2 = action.config.tenantTerms.targetMonthlyOptionPremium

      let projectionData2 = calculator2.getOptionValueProjections(6, false)

      return {
        ...state,
        calculator: calculator2,
        value: budget2,
        projectionData: projectionData2,
        rentingData: getRentingData(
          budget2,
          equityBuyback2
        )

      }
    case UPDATE_CALCULATOR_CONFIG:
      const calculator = new Calculator(action.config)
      const budget = action.config.tenantTerms.rent
      const equityBuyback = action.config.tenantTerms.targetMonthlyOptionPremium

      let projectionData

      if (action.includeYearZero) {
        projectionData = calculator.getOptionValueProjections(5, false)
      } else {
        const data = calculator.getOptionValueProjections(4, true)
        data.unshift(calculator.config.tenantTerms.initialOptionPremium)
        projectionData = data
      }

      return {
        ...state,
        calculator,
        value: budget,
        projectionData,
        rentingData: getRentingData(
          budget,
          equityBuyback
        )

      }
    default:
      return state
  }
}
